import { Component } from '@angular/core';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { ViewController } from 'ionic-angular';
import { Utilities } from '../../providers/utilities';
import { AppData } from '../../providers/app-data';

@Component({
    selector: 'disclaimer',
    templateUrl: 'disclaimer.html'
})
export class DisclaimerPage {

    constructor(public viewCtrl: ViewController, private appData: AppData, private utilities: Utilities) {
    }

    ngOnInit() {
        this.utilities.addDisclaimerClassToBody()
    }

    acceptDisclaimer() {
        this.appData.acceptedDisclaimer = true;
        this.viewCtrl.dismiss();
        Cookie.set('tire_disclaimer_accepted', 'true', this.appData.settings.disclaimerTimeoutDays);
    }

    exitApp() {
        window.location.href = 'http://www.penndot.pa.gov';
    }
}


// WEBPACK FOOTER //
// ./src/pages/disclaimer/disclaimer.ts